exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".topNav{\r\n  width: 100%;\r\n  height:50px;\r\n  padding-top:8px;\r\n  background-color: lightsalmon;\r\n  text-align: center;\r\n}\r\n\r\nh1{\r\n  margin: 0px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/top-nav/top-nav.component.css
// module id = 155
// module chunks = 1